import { useCallback, useEffect, useRef, useState } from 'react';
import { installerApi, contractorApi, putSigned } from '../../utils/installerApi';
import { toFa } from '../../utils/faFormat';
import CameraCapture from './CameraCapture';
import './installerFindings.css';
export const FOLLOWUP_STATUS = { open: 'باز', submitted: 'در انتظار بررسی ناظر', overdue: 'مهلت گذشته', resolved: 'رفع شد', cancelled: 'لغو شد' };
export const dueLabel = (value) => new Date(value).toLocaleDateString('fa-IR');
export function JobWarnings({ token, jobId, revision = 0, onAcknowledged }) {
  const [items, setItems] = useState([]); const [error, setError] = useState(''); const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(false);
  const active = useRef(null); const request = useRef(0); const binding = `${token}:${jobId}`;
  const load = useCallback(async () => {
    const serial = ++request.current;
    const current = () => active.current === binding && request.current === serial;
    setLoading(true); setError('');
    try { const out = await installerApi.warnings(token, jobId); if (current()) setItems(out.items || []); }
    catch (e) { if (current()) setError(e.message); }
    finally { if (current()) setLoading(false); }
  }, [token, jobId, binding]);
  useEffect(() => {
    active.current = binding; setItems([]); setError(''); setBusy(false);
    return () => { active.current = null; request.current += 1; };
  }, [binding]);
  useEffect(() => { load(); }, [load, revision]);
  const pending = items.filter((w) => !w.acknowledged_at);
  return <section className="inst-card inst-findings" aria-label="اخطارهای کار">
    <h3>اخطارهای کار</h3><p>اخطار امتیاز را کم نمی‌کند. پیش از ارسال بعدی و تکمیل کار، دیدن آن را تأیید کنید.</p>
    <button className="inst-btn inst-btn-ghost" disabled={busy || loading} onClick={load}>تازه‌سازی اخطارها</button>
    {error && <p role="alert">{error}</p>}
    {items.map((w) => <p key={w.id}>{toFa(w.text_fa)} {w.acknowledged_at && <strong>دیده شد</strong>}</p>)}
    {!!pending.length && <button className="inst-btn" disabled={busy || loading} onClick={async () => {
      setBusy(true); setError('');
      try {
        for (let start = 0; start < pending.length; start += 200) {
          if (active.current !== binding) return;
          await installerApi.ackWarnings(token, jobId, pending.slice(start, start + 200).map((w) => w.id));
        }
        if (active.current !== binding) return;
        await load();
        if (active.current === binding) onAcknowledged?.();
      }
      catch (e) { if (active.current === binding) setError(e.message); }
      finally { if (active.current === binding) setBusy(false); }
    }}>دیدن همهٔ اخطارها را تأیید می‌کنم</button>}
  </section>;
}
export function InstallerFollowups({ token }) {
  const [items, setItems] = useState([]); const [task, setTask] = useState(null); const [error, setError] = useState('');
  const [busy, setBusy] = useState(false); const [camera, setCamera] = useState(false); const [tickets, setTickets] = useState([]);
  const [note, setNote] = useState(''); const key = useRef(null); const active = useRef(null);
  const load = useCallback(async () => {
    try { const out = await installerApi.followups(token); if (active.current === token) setItems(out.items || []); }
    catch (e) { if (active.current === token) setError(e.message); }
  }, [token]);
  useEffect(() => { active.current = token; setItems([]); setTask(null); load(); return () => { active.current = null; }; }, [token, load]);
  const open = async (id) => {
    setBusy(true); setError('');
    try { const out = await installerApi.followup(token, id); if (active.current !== token) return; setTask(out.task); setTickets([]); setNote(''); key.current = crypto.randomUUID(); }
    catch (e) { if (active.current === token) setError(e.message); }
    finally { if (active.current === token) setBusy(false); }
  };
  const canSubmit = task && ['open', 'overdue'].includes(task.status) && !task.attempts?.some((a) => !a.decision);
  return <section className="inst-card inst-findings" aria-label="پیگیری‌های اصلاح">
    <h3>پیگیری‌های اصلاح</h3><p>حتی پس از تکمیل کار باید ایرادهای دارای مهلت را اصلاح کنید. پذیرش عکس با ناظر است.</p>
    <button className="inst-btn inst-btn-ghost" disabled={busy} onClick={load}>تازه‌سازی پیگیری‌ها</button>
    {error && <p role="alert">{error}</p>}
    {items.map((f) => <button className="inst-btn inst-btn-ghost" disabled={busy} key={f.id} onClick={() => open(f.id)}>
      {FOLLOWUP_STATUS[f.status]} · مهلت {dueLabel(f.due_at)}</button>)}
    {task && <div className="inst-followup-detail"><h4>{task.defect?.description}</h4><p>{task.defect?.corrective_action}</p>
      <p>{toFa(task.reason)} · مهلت {dueLabel(task.due_at)}</p>
      {!!task.penalty_applied_at && !task.overdue_penalty?.reversed_at && <p>کسر امتیاز مهلت ثبت شده است؛ رفع ایراد آن را خودکار برنمی‌گرداند.</p>}
      {task.overdue_penalty?.reversed_at && <p>کسر امتیاز با تصمیم مدیر برگشت داده شده است.</p>}
      {task.attempts?.map((a) => <div key={a.id}><p>{a.decision === 'rejected' ? 'رد شد' : a.decision === 'accepted' ? 'پذیرفته شد' : 'در انتظار ناظر'} {a.decision_note}</p>
        {a.evidence?.map((p) => <img key={p.id} src={p.url} alt={`عکس اصلاح ${toFa(p.ord)}`} />)}</div>)}
      {canSubmit && <><p>{toFa(tickets.length)} عکس تازه ثبت شده است.</p>
        <button className="inst-btn" disabled={busy || tickets.length >= 8} onClick={() => setCamera(true)}>گرفتن عکس اصلاح</button>
        <label className="inst-note">یادداشت اصلاح<textarea maxLength={2000} value={note} onChange={(e) => setNote(e.target.value)} disabled={busy} /></label>
        <button className="inst-btn" disabled={busy || !tickets.length} onClick={async () => {
          setBusy(true); setError('');
          try { await installerApi.submitFollowup(token, task.id, { client_key: key.current, ticket_ids: tickets, note }); if (active.current !== token) return; await open(task.id); await load(); }
          catch (e) { if (active.current === token) setError(e.message); }
          finally { if (active.current === token) setBusy(false); }
        }}>ارسال اصلاح برای ناظر</button>
        <CameraCapture open={camera} onClose={() => setCamera(false)} jobCode={task.job_id.slice(0, 6)} label="عکس اصلاح" onShot={async (shot) => {
          if (active.current !== token) throw new Error('نشست تغییر کرده است.');
          const out = await installerApi.followupTicket(token, task.id, { client_key: crypto.randomUUID(), kind: 'correction', sha256: shot.sha256,
            lat: shot.fix?.lat ?? null, lng: shot.fix?.lng ?? null, accuracy_m: shot.fix?.accuracy_m ?? null,
            fix_at: shot.fix ? new Date(shot.fix.fix_at).toISOString() : null, camera: shot.camera, offline: false, device_captured_at: new Date(shot.shutter_at).toISOString() });
          const upload = await installerApi.captureUploadUrl(token, out.ticket_id);
          if (!upload.uploaded) await putSigned(upload.signed_url, shot.blob);
          if (active.current !== token) return;
          setTickets((old) => [...old, out.ticket_id]); setCamera(false);
        }} />
      </>}
    </div>}
  </section>;
}
export function CompanyFollowups({ token, jobId }) {
  const [items, setItems] = useState([]); const [error, setError] = useState('');
  useEffect(() => {
    let active = true; setItems([]); setError('');
    contractorApi.followups(token, jobId).then((out) => { if (active) setItems(out.items || []); }).catch((e) => { if (active) setError(e.message); });
    return () => { active = false; };
  }, [token, jobId]);
  return <section className="inst-findings"><h4>پیگیری‌های باز گروه‌ها (فقط مشاهده)</h4>{error && <p role="alert">{error}</p>}
    {items.map((f) => <p key={f.id}>{toFa(f.reason)} · {FOLLOWUP_STATUS[f.status]} · مهلت {dueLabel(f.due_at)}</p>)}</section>;
}
